import { useEffect, useState } from 'react';
import { data, useNavigate } from 'react-router';
import { useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import moment from 'moment';

import { useTranslation } from 'react-i18next';
import { useGetBookingMutation } from '../../services/majesticResortsApi';
import MessageErrorModal from '../../ui/Modals/MessageErrorModal';
import CustomDateInput from '../../ui/Form/CustomDateInput';
import hotelList from '../../utils/hotels';
import { isEmptyObject } from '../../utils';
import purgeReducers from '../../utils/purgeReducers';
import IconDate from '../../assets/new-icons/calendar-min.png';
import IconLocalizador from '../../assets/new-icons/information-min.png';
import usePageNavigation from '../../hooks/usePageNavigation';
import useHotel from '../../hooks/useHotel';

function CheckingPage() {
  const { t } = useTranslation();
  const { hotel } = useSelector((state) => state.checking);
  // const [dataHotel, setDataHotel] = useState({});
  const [confirmSend, setConfirmSend] = useState(false);
  const [dataForm, setDataForm] = useState({});
  const [inputValue, setInputValue] = useState('');
  const [
    getBooking, {
      data: booking,
      isLoading,
      isError,
      error,
      isSuccess,
    },
  ] = useGetBookingMutation();
  const navigate = useNavigate();

  const { navigateNextPage } = usePageNavigation();

  const {
    control,
    register,
    formState: { errors, isSubmitted },
    handleSubmit,
  } = useForm();

  const {
    ref: refBooking,
    onChange: onChangeBooking,
    onBlur: onBlurBooking,
    name: nameBooking,
  } = register('bookingLocation', {
    required: t('TXT_ERROR_INPUT_REQUIRED', { inputName: t('TXT_BOOKING_LOCATOR') }),
    minLength: {
      value: 6,
      // Mensaje para minimo
      message: t('TXT_ERROR_INPUT_BOOKING_MIN'),
    },
    pattern: {
      // Validacion alfanumerica sin espacios, maximo 15 caracteres
      value: /^[A-Za-z0-9]{1,16}$/,
      message: t('TXT_ERROR_INPUT_BOOKING_REGEX'),
    },
  });

  const { dataHotel } = useHotel();

  useEffect(() => {
    // Elimina solo estos reducers
    purgeReducers(['booking', 'guests', 'ocr']);
  }, []);

  useEffect(() => {
    if (isSuccess && !isEmptyObject(booking)) {
      // console.log(booking);
      localStorage.setItem('session', 1);
      // navigate('/Booking');
      navigateNextPage('Booking');
    }
  }, [booking, isSuccess, navigateNextPage]);

  const handleSendData = async (data) => {
    setConfirmSend(false);
    const { bookingDate, bookingLocation } = data || dataForm;

    const pickupDate = moment(bookingDate).format('YYYYMMDD000000');
    // hotel, pickupDate, reservationNumber
    const params = {
      hotel,
      FechaEntrada: pickupDate,
      ReservationNumber: bookingLocation,
    };

    await getBooking(params).unwrap();
  };

  const onSubmit = async (data) => {
    // console.log(data.bookingDate)
    const fechaReferencia = moment(data.bookingDate);
    const fechaActual = moment();

    const diferenciaMs = fechaReferencia.diff(fechaActual); // Diferencia en milisegundos
    const horas48EnMs = 48 * 60 * 60 * 1000; // 48 horas en milisegundos

    if (false /*diferenciaMs >= horas48EnMs*/) {
      handleSendData(data);
    } else {
      // const tiempoRestante = moment.duration(horas48EnMs - diferenciaMs);
      // console.log(`
      //     Faltan:
      //     ${tiempoRestante.hours()} horas,
      //     ${tiempoRestante.minutes()} minutos,
      //     ${tiempoRestante.seconds()} segundos
      // `);
      setDataForm(data);
      setConfirmSend(true);
    }
  };

  const onError = (errorList) => {
    console.log(errorList);
  };

  return (
    <>
      <div className={`background-img-header background-img-header-${dataHotel.HotelCode} position-absolute w-100 start-0 top-0 end-0`} />
      <div className="checking__content position-relative">
        <div className="text-center pt-4">
          <p className="mb-0 app-fs-h5 app-lh-h5 app-lh-h6 app-fw-notosans-bold app-txt-granite">{dataHotel.HotelName}</p>

          <p className="mb-0 app-fs-6 app-fw-notosans-regular text-uppercase app-txt-granite">{dataHotel.HotelLocation}</p>
        </div>

        <div className="text-center mt-3">
          <p className="mb-0 app-fs-h2 app-lh-h2 app-fw-figtree-regular app-fs-h1">{t('TXT_TITLE_CHECK_IN')}</p>

          <p className="mb-0 app-txt-granite pt-2">{t('TXT_DATA_RESERVATION')}</p>
        </div>
        <Form onSubmit={handleSubmit(onSubmit, onError)} className="mt-3">
          <Card className={`border-solid-1 app-border-granite-80-light transition-border-color border-radius-5 mb-2 ${errors.bookingLocation ? 'invalid-input-border' : ''}`}>
            <Card.Body className="ps- -1 t-1">
              <div className="d-flex">
                <div className="checking__group-icon pe-3 d-flex align-items-center">
                  <img src={IconLocalizador} alt="IconLocalizador" className="img-fluid-33" />
                </div>
                <Form.Group className="flex-fill" controlId="bookingLocation">
                  <Form.Label className="mb-0 app-fw-notosans-bold app-txt-granite app-fs-14 text-uppercase">
                    {t('TXT_SEARCH_RESERVATION')}
                  </Form.Label>
                  <Form.Control
                    maxLength={16}
                    // value={inputValue}
                    ref={refBooking}
                    // onChange={handleInputChange}
                    onChange={onChangeBooking}
                    onBlur={onBlurBooking}
                    name={nameBooking}
                    className="w-100 app-fs-1 border-0 ps-0 py-0 shadow-none app-txt-granite-80-dark bg-transparent"
                    type="text"
                    placeholder={t('TXT_BOOKING_LOCATOR')}
                    rules={{
                      required: true,
                      minLength: {
                        value: 6,
                        message: '',
                      },
                      maxLength: {
                        value: 15,
                        message: '',
                      },
                    }}
                    // eslint-disable-next-line no-return-assign, no-param-reassign
                    onInput={(e) => (e.target.value = e.target.value.replace(/[^a-zA-Z0-9]/g, ''))}
                  />
                </Form.Group>
              </div>
              {/* Mostrar el mensaje de error solo si hay uno */}
              {errors.bookingLocation && (
                <Form.Text className="app-txt-red app-fs-12">
                  {errors.bookingLocation.message}
                </Form.Text>
              )}
            </Card.Body>
          </Card>

          <CustomDateInput
            control={control}
            name="bookingDate"
            rules={{ required: true }}
            blockDate={new Date()}
            icon={IconDate}
            formLabel={t('TXT_DATE_ENTRY')}
            labelId="bookingDate"
            placeHolder={t('TXT_DATE_ENTRY_PLACEHOLDER')}
            classNames={{
              icon: 'pe-3',
              card: 'border-solid-1 app-border-granite-80-light transition-border-color ',
              label: 'app-txt-granite-80-dark app-fw-notosans-bold app-fs-14 text-uppercase',
              input: 'py-0 app-txt-granite-80-dark bg-transparent',
            }}
          />

          <div className="mt-3">
            <Button
              variant=""
              type="submit"
              className="app-bg-sand app-fw-notosans-bold app-txt-granite w-100 rounded-3 btn-height border-0"
            >
              {t('TXT_BOTON_CONTINUE')}
            </Button>
          </div>
        </Form>
      </div>
      {/* {isLoading && <LoaderSpinner />} */}
      {isError && <MessageErrorModal message={error.message} />}

      {confirmSend && <MessageErrorModal message={t('TXT_CHECKIN_WARNING')} handleCloseModal={handleSendData} />}
    </>
  );
}

export default CheckingPage;
